<script setup>
import { isBoolean } from 'lodash';
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: Boolean, default: null },
});

const classes = computed(() => {
  if (isBoolean(props.modelValue)) {
    return props.modelValue ? 'fa fa-check text-success' : 'fa fa-times text-danger';
  }
  return 'fa fa-question text-info';
});

</script>

<template>
  <i :class="classes"></i>
</template>
